import React from 'react';
import { MapPin, Clock, Mail, Phone, Send } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';
import Reveal from './Reveal';

const ContactSection = () => {
  const CHURCH = useSettings();
  return (
    <section id="contact" className="bg-[#0f2e38] py-24 md:py-32 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#17565f]/40 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#2c8a95]/20 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <Reveal className="text-center mb-16">
          <p className="text-[#c9a24b] uppercase tracking-[0.34em] text-xs mb-4">Contact Us</p>
          <h2 className="font-serif-display italic text-white text-4xl md:text-6xl">
            Get in touch or drop in at a service
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <Reveal className="bg-white/5 border border-white/10 backdrop-blur-sm p-10 hover:border-[#c9a24b]/50 transition-colors duration-500">
            <h3 className="font-serif-display text-2xl text-white mb-8">Service Time &amp; Location</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Clock className="h-5 w-5 text-[#c9a24b] mt-1 shrink-0" />
                <p className="text-white/85">{CHURCH.serviceTime}</p>
              </div>
              <div className="flex items-start gap-4">
                <MapPin className="h-5 w-5 text-[#c9a24b] mt-1 shrink-0" />
                <p className="text-white/85">{CHURCH.address}<br />{CHURCH.city}</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120} className="bg-white/5 border border-white/10 backdrop-blur-sm p-10 hover:border-[#c9a24b]/50 transition-colors duration-500">
            <h3 className="font-serif-display text-2xl text-white mb-8">Contact Information</h3>
            <div className="space-y-6">
              <a href={`mailto:${CHURCH.email}`} className="flex items-start gap-4 group">
                <Mail className="h-5 w-5 text-[#c9a24b] mt-1 shrink-0" />
                <span className="text-white/85 group-hover:text-white transition-colors">{CHURCH.email}</span>
              </a>
              <a href={`tel:${CHURCH.phone}`} className="flex items-start gap-4 group">
                <Phone className="h-5 w-5 text-[#c9a24b] mt-1 shrink-0" />
                <span className="text-white/85 group-hover:text-white transition-colors">{CHURCH.phone}</span>
              </a>
              <div className="flex items-start gap-4">
                <Send className="h-5 w-5 text-[#c9a24b] mt-1 shrink-0" />
                <p className="text-white/85">{CHURCH.poBox}<br />{CHURCH.poCity}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
